<template>
    <div>
        <div class="listGallery" v-if="imageArray.length <= 3" :id="'gallery_'+optionId">
            <img 
                v-for="(imgName, index) in arrayToDisplay" 
                :key="index" 
                :index="index" 
                class="thumbnailList" 
                :id="'illus'+optionId+'_'+index" 
                :src="`https://preprod.api.defipix.fr/option/image/${optionId}/${imgName}`" 
                :alt="'Illustration de l\'option'"
                @click="displayImage(imgName)">
        </div>
        <div class="gallery" v-else :id="'gallery_'+optionId">
            <img 
                v-for="(imgName, index) in arrayToDisplay" 
                :key="index" 
                :index="index" 
                class="thumbnail" 
                :id="'illus'+optionId+'_'+index" 
                :src="`https://preprod.api.defipix.fr/option/image/${optionId}/${imgName}`" 
                :alt="'Illustration de l\'option'"
                @click="displayImage(imgName)">
        </div>
        <div v-if="imageArray.length > 9" class="buttonBar">
            <img class="arrow" :src="'https://preprod.api.defipix.fr/logos/prev_200.png'" alt="previous step" @click="prevPage" />
            <span class="counter">{{ page + 1 }} / {{ Math.ceil(imageArray.length/9) }}</span>
            <img class="arrow" :src="'https://preprod.api.defipix.fr/logos/next_200.png'" alt="next step" @click="nextPage" />
        </div>
        <div v-if="diaporama" class="diaporama">
            <div class="diapoContent">
                <div class="closeContainer">
                    <img class="closeBtn" :src="'https://preprod.api.defipix.fr/logos/close_200_pink.png'" alt="next step" @click="toggleDiaporama" />
                </div>
                <img class="diaporamaImage" :src="`https://preprod.api.defipix.fr/option/image/${optionId}/${imageSelected}`"  alt="view of diaporama" @click="toggleDiaporama" />
                <div class="buttonBar">
                    <img class="arrow" :src="'https://preprod.api.defipix.fr/logos/prev_200.png'" alt="previous step" @click="prevImage" />
                    <span class="counter black">{{ imageArray.indexOf(imageSelected) + 1}} / {{ imageArray.length }}</span>
                    <img class="arrow" :src="'https://preprod.api.defipix.fr/logos/next_200.png'" alt="next step" @click="nextImage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JQuery from 'jquery';
let $ = JQuery;

export default {
    data() {
        return {
            arrayToDisplay: [],
            page: 0,
            diaporama: false,
            imageSelected: null,
        }
    },
    mounted: function () {
        let sizeOfArray = this.imageArray.length;
        if (sizeOfArray > 6) {
            $("#gallery_"+this.optionId).css("grid-template-rows","1fr 1fr 1fr");
        } else if (sizeOfArray > 3) {
            $("#gallery_"+this.optionId).css("grid-template-rows","1fr 1fr");
        } else {
            $("#gallery_"+this.optionId).css("grid-template-rows","1fr");
        }

        for (let i = 0; i < 9; i++) {
            if(this.imageArray[i]) {
                this.arrayToDisplay.push(this.imageArray[i]);
            }
        }

        document.addEventListener('keydown', (event) => {
            if (event.keyCode === 27 && this.diaporama) {
                this.toggleDiaporama();
            }
            if (event.keyCode === 39 && this.diaporama) {
                this.nextImage();
            }
            if (event.keyCode === 37 && this.diaporama) {
                this.prevImage();
            }
        }, false);
    },
    methods: {
        nextPage() {
            if ((this.page+1)*9 > this.imageArray.length) return;
            this.arrayToDisplay = [];
            for (let i = (this.page+1)*9; i < (this.page+1)*9+9; i++) {
                if(this.imageArray[i]) {
                    this.arrayToDisplay.push(this.imageArray[i]);
                }
            };
            this.page++;
        },
        prevPage() {
            if (this.page === 0 ) return;
            this.arrayToDisplay = [];
            for (let i = (this.page-1)*9; i < (this.page-1)*9+9; i++) {
                if(this.imageArray[i]) {
                    this.arrayToDisplay.push(this.imageArray[i]);
                }
            };
            this.page--;
        },
        displayImage(name) {
            this.imageSelected = name;
            this.toggleDiaporama();
        },
        toggleDiaporama() {
            this.diaporama = !this.diaporama;
        },
        nextImage() {
            if (this.imageArray.indexOf(this.imageSelected) + 1 === this.imageArray.length) return;
            let positonNext = this.imageArray.indexOf(this.imageSelected) + 1;
            this.imageSelected = this.imageArray[positonNext];
        },
        prevImage() {
            if (this.imageArray.indexOf(this.imageSelected) === 0) return;
            let positonNext = this.imageArray.indexOf(this.imageSelected) - 1;
            this.imageSelected = this.imageArray[positonNext];
        }
    },
    props: {
        imageArray: Array,
        optionId: Number,
    }
}

</script>

<style scoped>

.listGallery {
    grid-template-rows: unset !important;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.gallery {
    display: grid;
    grid-gap: 5px;
    grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
    grid-auto-rows: 1fr;
    margin: 0.5em;
    overflow: hidden;
}

.gallery::before {
  content: '';
  width: 0;
  padding-bottom: 100%;
  grid-row: 1 / 1;
  grid-column: 1 / 1;
}

.gallery > *:first-child {
  grid-row: 1 / 1;
  grid-column: 1 / 1;
}

.thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
}

.thumbnailList {
    width: 80%;
    height: 80%;
    margin: 1em 0;
    border: 2px solid#f677c4;
    border-radius: 5px;
}

.thumbnailList:hover {
    cursor: pointer;
    transform: scale(1.01);
}

.buttonBar {
    display: flex;
    justify-content: center;
}

.counter {
    color: #fff;
    font-weight: 700;
}

.arrow {
    width: 2em;
    height: 2em;
    margin: 0 1em;
}

.arrow:hover, .thumbnail:hover, .closeBtn:hover {
    cursor: pointer;
    transform: scale(1.05);
}

.diaporama {
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: rgba(112, 112, 112, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.diapoContent {
    background-color: #fff;
    padding: 1em;
    border-radius: 5px;
}

.closeContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.closeBtn {
    color: #f677c4;
    width: 1.5em;
    height: 1.5em;
}

.diaporamaImage {
    display: block;
    max-width: 80vw;
    max-height: 80vh;
    margin: 1em auto;
    border: 1px solid rgb(245, 245, 245);
}

.black {
    color: #000;
}

</style>


// WEBPACK FOOTER //
// src/components/Options/Gallery.vue